export const useVillaTranslation = () => {
  const translateEntity = (entity: string): string => {
    switch (entity) {
      case "STATE": {
        return "استان";
      }
      case "CITY": {
        return "شهر";
      }
      case "VILLAGE": {
        return "روستا";
      }
      case "AREA": {
        return "منطقه";
      }
      case "COUNTRY": {
        return "کشور";
      }
      default: {
        return "";
      }
    }
  };

  return {
    translateEntity
  };
};
